import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../icons/logo-main-white.svg'
import _imports_1 from '../icons/logo-main.svg'
import _imports_2 from '../icons/oa-logo.svg'


const _hoisted_1 = {
  key: 0,
  class: "waiting-server"
}
const _hoisted_2 = {
  key: 0,
  class: "drop-area-message"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Déposez vos fichiers ici.", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "add-files-area" }
const _hoisted_6 = {
  key: 0,
  class: "files-button"
}
const _hoisted_7 = { class: "files" }
const _hoisted_8 = { class: "header-column" }
const _hoisted_9 = { class: "files-container" }
const _hoisted_10 = { class: "button-add-more-files" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h1", null, " Cliquez ici pour ajouter vos fichiers ou glissez-les dans la fenêtre ", -1)
const _hoisted_12 = {
  key: 1,
  class: "welcome-button"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_14 = { class: "btn-info" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h1", { class: "click-here" }, " Cliquez ici pour ajouter vos fichiers ou glissez-les dans la fenêtre ", -1)
const _hoisted_16 = {
  key: 0,
  class: "form-container"
}
const _hoisted_17 = {
  ref: "form_settings",
  class: "form-settings"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "header-column" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "destination" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Destinataire"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      alt: ""
    })
  ])
], -1)
const _hoisted_19 = { class: "inputs" }
const _hoisted_20 = { class: "input-label message" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "message" }, "Message", -1)

import { defineComponent, onMounted, Ref, ref, watch } from "vue";
import DropZone from "@/components/DropZone.vue";
import ButtonAddFiles from "@/components/ButtonAddFiles.vue";
import useFileList from "../compositions/file-list";
import store from "@/store";
import { computed } from "@vue/reactivity";
import FilePreview from "../components/FilePreview.vue";
import {
  formatSize,
  validMail,
  validPass,
  go_back_home,
} from "@/compositions/functions";
import { constants } from "@/compositions/constants";
import AdditionnalSettings from "@/components/AdditionnalSettings.vue";
import { uploadFile } from "@/compositions/upload";
import LoadingScreen from "../components/LoadingScreen.vue";

import router from "@/router";
import axios from "axios";

// import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const testing_server = ref(true);

const input_title = ref() as Ref<HTMLInputElement>;

const valid_mail = ref(true);
const valid_title = ref(true);

const header_files_number = computed(() => {
  const l = store.state.files.length;
  if (l == 1) {
    return "1 fichier téléchargé";
  } else {
    return l + " fichiers téléchargés";
  }
});

const home_class = computed(() => {
  if (store.state.files.length > 0) {
    return "home home-larger";
  } else {
    return "home";
  }
});

const mailForm = ref(true);

const total_size = computed(() => {
  return store.state.files.reduce(
    (previousValue, currentValue) =>
      previousValue + (currentValue.file.size as number),
    0
  );
});

const oa_receiver = ref(true);

const active_transfer_button = computed(() => {
  if (!validMail(store.state.email_from)) {
    return false;
  }

  if (!store.state.params.title) {
    return false;
  }

  return true;
});

const startTransfer = () => {
  const input_sender = document.querySelector(
    ".input-sender"
  ) as HTMLInputElement;
  let err = false;
  valid_mail.value = true;
  valid_title.value = true;

  // if (!validMail(store.state.email_from)) {
  //   valid_mail.value = false;
  //   err = true;
  // }

  if (!err) {
    store.state.upload_size = total_size.value;
    uploadFile(mailForm.value, input_sender.value);
    router.push("/uploading");
  }
};

onMounted(async () => {
  const fd = new FormData();
  fd.append("test", "200");
  await axios
    .post(constants.API + "/" + "test", fd)
    .then((res) => {
      if (res.status === 200) {
        testing_server.value = false;
      }
    })
    .catch(function (error) {
      //on fait rien car le logo va tourner en attendant que la connexion soit etablie
    });
  let inter = setInterval(async () => {
    if (testing_server.value) {
      await axios
        .post(constants.API + "/" + "test", fd)
        .then((res) => {
          if (res.status === 200) {
            testing_server.value = false;
          }
        })
        .catch(function (error) {
          //nothing
        });
    } else {
      clearInterval(inter);
    }
  }, 2000);
});

return (_ctx: any,_cache: any) => {
  return (testing_server.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(LoadingScreen)
      ]))
    : (_openBlock(), _createBlock(DropZone, {
        key: 1,
        class: "drop-area",
        onFilesDropped: _cache[6] || (_cache[6] = (newFiles) => _unref(store).commit('addFiles', newFiles))
      }, {
        default: _withCtx(({ dropZoneActive }) => [
          dropZoneActive
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
            : _createCommentVNode("", true),
          (_unref(store).state.files.length > 0)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "woah-logo",
                src: _imports_0,
                alt: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(go_back_home)()))
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(_unref(home_class))
          }, [
            _createElementVNode("div", _hoisted_5, [
              (_unref(store).state.files.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("h1", null, _toDisplayString(_unref(header_files_number)), 1),
                        _createElementVNode("h2", null, _toDisplayString(_unref(formatSize)(_unref(total_size))) + " / " + _toDisplayString(_unref(formatSize)(_unref(constants).max_size)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.files, (file, i) => {
                          return (_openBlock(), _createBlock(FilePreview, {
                            key: file.id,
                            index: i,
                            file: file
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(file.filename), 1)
                            ]),
                            _: 2
                          }, 1032, ["index", "file"]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(ButtonAddFiles),
                      _hoisted_11
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(ButtonAddFiles, { class: "button-add-files" }),
                      _hoisted_15,
                      _createElementVNode("h3", null, " (max: " + _toDisplayString(_unref(formatSize)(_unref(constants).max_size)) + " / " + _toDisplayString(_unref(constants).max_files) + " fichiers - vos fichiers seront stockés 30 jours sur nos serveurs) ", 1)
                    ])
                  ]))
            ]),
            (_unref(store).state.files.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", {
                        class: _normalizeClass(valid_mail.value ? 'input-label' : 'input-label error-mail')
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          onFocusin: _cache[1] || (_cache[1] = ($event: any) => (valid_mail.value = true)),
                          class: "input-sender",
                          type: "email",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(store).state.email_from) = $event)),
                          placeholder: "De la part de",
                          required: ""
                        }, null, 544), [
                          [_vModelText, _unref(store).state.email_from]
                        ])
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(valid_title.value ? 'input-label' : 'input-label error-title')
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          onFocusin: _cache[3] || (_cache[3] = ($event: any) => (valid_title.value = true)),
                          ref_key: "input_title",
                          ref: input_title,
                          type: "text",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(store).state.params.title) = $event)),
                          placeholder: "Titre",
                          required: ""
                        }, null, 544), [
                          [_vModelText, _unref(store).state.params.title]
                        ])
                      ], 2),
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(store).state.params.message) = $event)),
                          name: "message",
                          id: "",
                          cols: "30",
                          rows: "3"
                        }, null, 512), [
                          [_vModelText, _unref(store).state.params.message]
                        ])
                      ])
                    ])
                  ], 512),
                  _createElementVNode("button", {
                    onClick: startTransfer,
                    class: _normalizeClass(
            _unref(active_transfer_button)
              ? 'start_transfer active_btn'
              : 'start_transfer unactive_btn'
          )
                  }, " Transférer ", 2)
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 1
      }))
}
}

})